import { useSetRecoilState } from "recoil";
import { authAtom } from "../../recoil/atoms";
import { useMutation, useQuery } from "react-query";
import { getAdvertisements } from "../../api/advertisement";
import { subscribeAndSetToken } from "../../api/fcmApi";

export const useAdvertisements = () => {
  const setAuthAtom = useSetRecoilState(authAtom);
  const onError = ({ response: { status } }) => {
    if (status === 401) {
      setAuthAtom({ isLoggedIn: false, username: null, name: null });
    }
  };

  return useQuery("advertisements", getAdvertisements, {
    select: (data) => data.data,
    onError,
  });
};

export const useSubscribeAndSetToken = () => {
  const setAuthAtom = useSetRecoilState(authAtom);

  const onError = ({ response: { status } }) => {
    if (status === 401) {
      // 인증에 실패한 경우는 로그아웃시키고 재로그인하도록 해야한다.
      setAuthAtom({ isLoggedIn: false, username: null, name: null });
    }
  };
  const onSuccess = () => {};
  return useMutation(subscribeAndSetToken, {
    onError,
    onSuccess,
  });
};
